import React, { ReactElement } from 'react'
import './PartnerCard.scss'
import gsap from 'gsap'
import { Flip } from 'gsap/Flip'

interface PartnerCardProps {
	image: string,
	text: ReactElement | null,
	name: string
}


const PartnerCard: React.FC<PartnerCardProps> = (props: PartnerCardProps) => {

	const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
		const cont = document.getElementById('partnercardscontainer')
		let card = event.currentTarget
		let image = card?.getElementsByClassName('image')[0]
		let text = card?.getElementsByClassName('text')[0]
		const startH = cont?.offsetHeight
		if (cont && startH) {
			if (text.classList.contains('d-none')) {
				cont.style.minHeight = startH + 300 + 'px'
			} else {
				cont.style.minHeight = startH + 'px'
			}
		}
		let state = Flip.getState('.partnerCard, .footer, .image, .text, .pointer, .partners, #partnercards')
		card?.classList.toggle('col-md-4')
		image?.classList.toggle('col-md-4')
		text?.classList.toggle('d-none')
		Flip.from(state, {
			nested: true,
			absolute: true,
			ease: "power2.inOut",
            duration: 1,
			prune: true,
            onEnter: elements => gsap.fromTo(elements, {opacity: 0}, {opacity: 1, duration:1}),
            onLeave: elements => gsap.fromTo(elements, {opacity: 1}, {opacity: 0, duration:1}),
			onComplete: () => {if(cont) cont.style.minHeight = '0'}
		})
	}
	console.log(props.text)
	return(<div className={props.text ? 'partnerCard col-md-4 shadow cursor-pointer' : 'partnerCard col-md-4 shadow'} onClick={props.text ? handleClick : undefined} id={props.name}>
		{props.text ? <div className="no-size"><svg className="pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.<path d="M160 64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 136c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c7.8 0 14.3 5.6 15.7 13c1.6 8.2 7.3 15.1 15.1 18s16.7 1.6 23.3-3.6c2.7-2.1 6.1-3.4 9.9-3.4c8.8 0 16 7.2 16 16l0 16 0 104c0 39.8-32.2 72-72 72l-56 0-59.8 0-.9 0c-37.4 0-72.4-18.7-93.2-49.9L50.7 312.9c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4L116 353.2c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23l0-19.9 0-256zM176 0c-35.3 0-64 28.7-64 64l0 197.7C91.2 238 55.5 232.8 28.5 250.7C-.9 270.4-8.9 310.1 10.8 339.5L78.3 440.8c29.7 44.5 79.6 71.2 133.1 71.2l.9 0 59.8 0 56 0c66.3 0 120-53.7 120-120l0-104 0-16c0-35.3-28.7-64-64-64c-4.5 0-8.8 .5-13 1.3c-11.7-15.4-30.2-25.3-51-25.3c-6.9 0-13.5 1.1-19.7 3.1C288.7 170.7 269.6 160 248 160c-2.7 0-5.4 .2-8 .5L240 64c0-35.3-28.7-64-64-64zm48 304c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zm48-16c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96z"/></svg></div>:null}
		<div className="card-image">
			<div className="row">
				<div className='image'><img src={props.image} alt={props.name} /></div>
				<div className='text col-md-8 d-none'>{props.text}</div>
			</div>
		</div>
	</div>)
}

export default PartnerCard